export default __webpack_public_path__ + "static/media/liberty-thumbnail.f8dc9d74.jpg";